import { environment } from '../environments/environment';
export const API_VERSION = 'api';
export const BASE_URL = environment.BASE_URL;


// WEBPACK FOOTER //
// ./src/app/base_url.ts